import React, { createContext } from 'react';
export const I18nContext = createContext({});
export const I18nProvider = ({ messages, locale, children }) => (React.createElement(I18nContext.Provider, { value: { locale, messages } }, children));
//# sourceMappingURL=context.js.map